module.exports = __webpack_public_path__ + "img/upays_screen_0_1.3a30044d.png";